
export default {

  data () {
    return {
      cc_buttonDisplayMS: 10000, // time in milliseconds to display validation/creation success buttons
    }
  }
}